export default {
  ResinvoiceHistory: "سجل الفواتير",
  RessearchInvoice: "ابحث برقم الفاتورة...",
  ResnoInvoices: "لا توجد فواتير",
  Resinvoice: "الفاتورة",
  Resorder: "الطلب",
  Resdate: "التاريخ",
  Restotal: "المجموع",
  Resstatus: "الحالة",
  Resview: "عرض",

  ResinvoiceDetails: "تفاصيل الفاتورة",
  ResdownloadInvoice: "تحميل ملف الفاتورة PDF",
  ResinvoiceIdNotFound: "رقم الفاتورة غير موجود",
  ResdownloadFailed: "فشل تحميل ملف الفاتورة",

  RessupplierDetails: "تفاصيل المورد",
  Resname: "الاسم",
  Rescontact: "جهة الاتصال",
  Resmobile: "الجوال",
  Resemail: "البريد الإلكتروني",

  Resitems: "العناصر",
  Resproduct: "المنتج",
  Resqty: "الكمية",
  Resprice: "السعر",
  Resdiscount: "الخصم",
};